'use client'

import { useEffect, useRef, type PropsWithChildren } from 'react'

import VolumeOff from 'asset/icon/video_volume_off.svg'
import VolumeOn from 'asset/icon/video_volume_on.svg'
import { Button } from 'component/ui/button'
import { Portal } from 'component/ui/portal'
import { mutedStore, useIsMuted, userPausedStore } from 'store/global/video'

const SpotList = (props: PropsWithChildren) => {
  const { children } = props
  // video player states
  const ref = useRef<HTMLDivElement>(null)
  const isMuted = useIsMuted()

  useEffect(() => {
    if (!ref.current) {
      return
    }

    const element = ref.current
    function disableSpacebarScroll(e: KeyboardEvent) {
      if (e.key === ' ') {
        e.preventDefault()
      }
    }
    element.addEventListener('keydown', disableSpacebarScroll)

    // prevent space key scroll
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === ' ' && e.target === document.body) {
        e.preventDefault()
      }
    }
    function detectKeyDown(e: KeyboardEvent) {
      if (e.key === ' ') {
        userPausedStore.toggle()
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    window.addEventListener('keydown', detectKeyDown)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
      window.removeEventListener('keydown', detectKeyDown)
      element.removeEventListener('keydown', disableSpacebarScroll)
    }
  }, [])

  return (
    <>
      <div
        ref={ref}
        className='no-scrollbar h-full snap-y snap-mandatory scroll-pb-[--scroll-padding-bottom] scroll-pt-[--scroll-padding-top] overflow-y-scroll pb-[--scroll-padding-bottom] pt-[--scroll-padding-top] playsee-mb:scroll-py-0 playsee-mb:py-0'
      >
        {children}
      </div>
      <Portal>
        <Button
          $icon
          $variant='text'
          $size='lg'
          className='fixed right-0 top-[--fixed-top] z-modal m-[12px] hidden playsee-mb:flex'
          onClick={mutedStore.toggle}
        >
          {isMuted ? (
            <VolumeOff className='sq-[25px]' />
          ) : (
            <VolumeOn className='sq-[25px]' />
          )}
        </Button>
      </Portal>
    </>
  )
}

export default SpotList
